module.exports = __webpack_public_path__ + "img/sattelite.042219dc.svg";